import { ThemeProvider } from '@ui5/webcomponents-react';
import { ToastContainer } from 'react-toastify';
import Routes from './pages/routes';

import '@ui5/webcomponents-icons/dist/AllIcons';
import '@ui5/webcomponents/dist/features/InputElementsFormSupport';

export default function App() {

    return (
        <>
            <ThemeProvider>
                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <Routes />
            </ThemeProvider>
        </>
    )

}